/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Main_Characters_PlaceholderInputs */

const en_main_characters_placeholder = /** @type {(inputs: Main_Characters_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. David, Sarah, the park ranger...`)
};

const fr_main_characters_placeholder = /** @type {(inputs: Main_Characters_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Par exemple, David, Sarah, le garde forestier...`)
};

const de_main_characters_placeholder = /** @type {(inputs: Main_Characters_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`z.B. David, Sarah, der Parkwächter...`)
};

const it_main_characters_placeholder = /** @type {(inputs: Main_Characters_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ad esempio David, Sarah, il guardaparco...`)
};

const ru_main_characters_placeholder = /** @type {(inputs: Main_Characters_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`например, Дэвид, Сара, смотритель парка...`)
};

const es_main_characters_placeholder = /** @type {(inputs: Main_Characters_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por ejemplo, David, Sarah, el guardaparques...`)
};

const zh_cn2_main_characters_placeholder = /** @type {(inputs: Main_Characters_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`例如：大卫、莎拉、公园管理员……`)
};

const ja_main_characters_placeholder = /** @type {(inputs: Main_Characters_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`例：デイビッド、サラ、公園管理人…`)
};

const hi_main_characters_placeholder = /** @type {(inputs: Main_Characters_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उदाहरण के लिए, डेविड, सारा, पार्क रेंजर...`)
};

const pt_pt2_main_characters_placeholder = /** @type {(inputs: Main_Characters_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por exemplo, David, Sarah, o guarda-parque...`)
};

/**
* | output |
* | --- |
* | "e.g. David, Sarah, the park ranger..." |
*
* @param {Main_Characters_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const main_characters_placeholder = /** @type {((inputs?: Main_Characters_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Main_Characters_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_main_characters_placeholder(inputs)
	if (locale === "de") return de_main_characters_placeholder(inputs)
	if (locale === "it") return it_main_characters_placeholder(inputs)
	if (locale === "ru") return ru_main_characters_placeholder(inputs)
	if (locale === "es") return es_main_characters_placeholder(inputs)
	if (locale === "zh-CN") return zh_cn2_main_characters_placeholder(inputs)
	if (locale === "ja") return ja_main_characters_placeholder(inputs)
	if (locale === "hi") return hi_main_characters_placeholder(inputs)
	if (locale === "pt-PT") return pt_pt2_main_characters_placeholder(inputs)
	return en_main_characters_placeholder(inputs)
});